    
<template>
  <common-page-layout>     
    <span slot="fixedtopbuttons">
      <add-button @click="$refs.businessesdialog.show()">Business</add-button>    
      <large-button  @click="refresh()">Refresh</large-button>
    </span>   
      
      <p>
        <font color="green">
        Here you can view all your linked businesses that will be used in the creation of remedial's related to you.  Clicking the details of a business will allow you to manage rights for that business.
        </font>
      </p>

      <p>
        <font color="green"><b>On any changes please refresh the page using the Refresh button to ensure the latest changes are shown.</b>
        </font>
      </p>

    <h3>Linked Businesses</h3>    
    <ul class="ul-layout">
          <li class="li-layout " :key="index" v-for="(linkedbusiness,index) in linkedbusinesses"
            @click="$refs.businessdialog.show({business:{id:index},meta:{linkedbusiness:{id:index,allowcreateremedial:linkedbusiness.allowcreateremedial}}})">
              <business-info-layout :business="{name:linkedbusiness.name}"> 

                  <businesses-layout-item v-if="linkedbusiness.allowcreateremedial">
                      <b>Create Remedials</b>
                  </businesses-layout-item>

                  <businesses-layout-item>
                    <large-button>Details</large-button>
                  </businesses-layout-item>
              </business-info-layout>
          </li>
    </ul>
    <h3>Lodge Businesses</h3>
    <ul class="ul-layout">
          <li class="li-layout " :key="index" v-for="(lodgebusiness,index) in lodgebusinesses">
              <business-info-layout :business="{name:lodgebusiness.name,address:lodgebusiness.address}"/>                 
          </li>
    </ul>

    <businesses-links-dialog ref="businessesdialog" :selectedBusinesses="linkedbusinesses" @link="addLinkToBusiness"/>  
    
    <business-dialog ref="businessdialog"> 
          <template slot-scope="slotProps" v-if="slotProps && slotProps.meta">
            <span>
              <p><font color="green">Here you can update rights for a business or simple remove the business from your reference list.</font></p>
            </span> 
            <p>              
              <large-button @click="togglecreateremedial(slotProps.meta.linkedbusiness)">{{slotProps.meta.linkedbusiness.allowcreateremedial?"Disable ":"Enable"}} Create Remedial</large-button>                                     
            </p>
            <confirm-dialog                   
              usedefaultbutton buttontext="Remove Link" id="removebusiness" @click="actionremovebusiness($event,slotProps.business)" oktext="Yes Remove">        
              Warning this cannot be undone, please double check.
            </confirm-dialog>  
          </template>
    </business-dialog>

  </common-page-layout>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";
  // var mounted=true;
  export default {
    data: function() {
      return {        
        linkedbusinesses:null,
        lodgebusinesses:null
      }
    },
    methods: {  
      refresh(){
           this.getlinkedlist()
      },  

      
      addLinkToBusiness(linkedbusiness){             
          linkedbusiness.allowcreateremedial = true          
          this.businesslinkcommands({linkedbusiness,command:'addLinkToBusiness'})                    
      },

      togglecreateremedial(linkedbusiness){   
        console.log(linkedbusiness)
          let toggle = linkedbusiness.allowcreateremedial===undefined?true:!linkedbusiness.allowcreateremedial
          linkedbusiness.allowcreateremedial = toggle          
          this.businesslinkcommands({linkedbusiness,command:'toggleDirectRemedialCreation'})          
          this.$refs.businessdialog.cancelDialog()      
      },
      actionremovebusiness(args,linkedbusiness){
        if(args.action){
          this.businesslinkcommands({linkedbusiness,command:'removeLinkedBusiness'})
        }   
        this.$refs.businessdialog.cancelDialog()      
      },
      getlinkedlist(){
          this.linkedbusiness({business:this.business}).then((businessslist)=>{                                   
            this.linkedbusinesses = businessslist
          })
      },

      getLodgelist(){
          this.lodgewithbusinesses({business:this.business}).then((lodgebusinesses)=>{                                   
            this.lodgebusinesses = lodgebusinesses
          })
      },

      ...mapActions(['changeBusiness','lodgewithbusinesses','businesscommands','businesslinkcommands','fullbusiness','linkedbusiness','selfgroupcommands'])
    },
    computed: {
      ...mapGetters(["adminrights","alladminrights","sysadmin","business"])
    },    
    created(){
        this.getlinkedlist();
        this.getLodgelist();
    }
  
  };
</script>

 <style>

  .ul-layout{
    list-style-type: none;   
  }
   
  .li-layout {
    display: inline-block;
    max-width: 350px;
    padding: 10px;
  }    
  </style>
 


// WEBPACK FOOTER //
// src/components/admin/AdminBusinessLinks.vue